/**
 * Module that can ecsign a message with a private key, altered to match ecsign and ecrecover
 * on the Energi Core Gen3 network.
 *
 *
 * <i>Copyright (c) 2019 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module ecsign.js
 * @class EcSign
 * @since 0.0.1
*/

const Web3 = require('web3'),
    ethjsUtil = require('ethereumjs-util'),
    Web3Utils = Web3.utils;

/**
 * Ecsigns a message with a private key. Takes a parsed Gen2 key (modified to match Energi Core Gen3) and signs a hash.
 *
 * @method sign
 * @param hash {String} hexadecimal hash, starting with '0x'
 * @param parsedPrivateKey {String} The parsed (modified) Gen2 private key that is used to sign.
 * @return {Array} new array containing the ecsign values v, r and s.
 * @since 0.0.1
 */
const sign = (hash, parsedPrivateKey) => {
    let sig, v;
    const hashBuffer = Buffer.from(hash.substr(2), 'hex'),
        privateKeyBuffer = Buffer.from(parsedPrivateKey, 'hex');

    sig = ethjsUtil.ecsign(
        hashBuffer,
        privateKeyBuffer
    );
    // v should be 0 or 1 to succeed
    // because ethjsUtil.ecsign internally add 27, we need to adjust:
    // https://github.com/ethereumjs/ethereumjs-util/blob/master/src/signature.ts#L26
    v = sig.v - 27;
    return [v, Web3Utils.hexToBytes('0x'+sig.r.toString('hex')), Web3Utils.hexToBytes('0x'+sig.s.toString('hex'))];
};

module.exports = {
    sign
};
